import { selectIsAuth } from '@features/auth/store/auth.selectors';
import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export interface GuestRouteProps {
  children: ReactNode;
}

export const GuestRoute: FC<GuestRouteProps> = ({ children }) => {
  const isAuth = useSelector(selectIsAuth);

  if (isAuth) {
    return <Navigate to='/home' replace />;
  }

  return <>{children}</>;
};
